export default __webpack_public_path__ + "static/media/bb17.68a97a59.webp";